export const FLOW_STATIC_METRICS_DISPLAY = {
  AppSubscribers: {
    name: 'Users with Complete',
    description:
      'The number of unique users who performed complete events within the selected time interval.',
  },
  AppTotalEvents: {
    name: 'Complete Events',
    description: 'The number of complete events that occurred within the selected time interval.',
  },
};

export const FLOW_METRICS_DISPLAY = {
  init: {
    name: 'Init',
    shortName: 'Init',
    description: 'The number of times the initial event triggered the flow.',
  },
  avg_complete_duration: {
    name: 'Complete Duration',
    shortName: 'Duration',
    description:
      'The average time from the first initial event to the complete event within the Flow completion window, max 1 hour.',
  },
  success: {
    name: 'Success',
    shortName: 'Success',
    description:
      'The number of completed event pairs (first initial event followed by a complete event within the configured flow success window) divided by the total number of init.',
  },
  complete: {
    name: 'Complete',
    shortName: 'Complete',
    description: '',
  },
  total_error_count: {
    name: 'Total Error Count',
    shortName: 'Error',
    description:
      'The number of errors encountered after the first initial event within the flow completion window, maximum 1-hour.',
  },
  network_request_avg_duration: {
    name: 'Network Request Avg Duration',
    shortName: 'Network Request Duration',
    description:
      'The average network request response time after the first initial event within the flow completion window, maximum 1-hour.',
  },
  network_request_failure: {
    name: 'Network Request Failure',
    shortName: 'Network Request Failure',
    description:
      'The number of network request failures on or after the first initial event within the flow completion window, maximum 1-hour.',
  },
  network_request_count: {
    name: 'Network Request Count',
    shortName: 'Network Request Count',
    description: '',
  },
  'non-critical_error': {
    name: 'Non-Critical Error',
    shortName: 'Non-Critical Error',
    description: '',
  },
  critical_error: {
    name: 'Critical Error',
    shortName: 'Critical Error',
    description: '',
  },
  abandoned_flows_with_errors: {
    name: 'Abandoned Flows with Errors',
    shortName: 'Abandoned Errors',
    description: '',
  },
  completed_flows_with_errors: {
    name: 'Completed Flows with Errors',
    shortName: 'Completed Errors',
    description: '',
  },
  errors_in_abandoned_flows: {
    name: 'Errors in Abandoned Flows',
    shortName: 'Abandoned Errors',
    description: '',
  },
  errors_in_completed_flows: {
    name: 'Errors in Completed Flows',
    shortName: 'Completed Errors',
    description: '',
  },
  flows_with_errors: {
    name: 'Flows with Errors',
    shortName: 'Flows with Errors',
    description: '',
  },
  abandoned_flows: {
    name: 'Abandoned Flows',
    shortName: 'Abandoned Flows',
    description: '',
  },
};

export const FRUSTRATION_SIGNAL_METRICS_DISPLAY = {
  count: {
    name: 'Signal Count',
    shortName: 'Signal Count',
    description:
      'The total number of frustration signals detected within the selected time interval.',
  },
  with_user: {
    name: 'Impacted Users',
    shortName: 'Impacted Users',
    description:
      'The number of unique users who experienced frustration signals within the selected time interval.',
  },
  with_session: {
    name: 'Impacted Sessions',
    shortName: 'Impacted Sessions',
    description:
      'The number of unique sessions which experienced frustration signals within the selected time interval.',
  },
};
